import { render } from "./PlayBookItem.vue?vue&type=template&id=6bbebc26&scoped=true&ts=true"
import script from "./PlayBookItem.vue?vue&type=script&lang=ts"
export * from "./PlayBookItem.vue?vue&type=script&lang=ts"

import "./PlayBookItem.vue?vue&type=style&index=0&id=6bbebc26&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbebc26"]])

export default __exports__